export const RestreamingConnectedBadgeColor = '#36DD39';
